import { createSvgIcon } from '@mui/material'

export const CopyIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <g clipPath='url(#clip0_3645_10984)'>
      <path
        d='M17.7562 9.06358L13.5938 4.31367C13.5061 4.21525 13.3991 4.13652 13.2796 4.08253C13.1601 4.02854 13.0308 4.00048 12.9 4.00017H5.4C5.08852 3.99641 4.77935 4.05485 4.49016 4.17217C4.20096 4.28949 3.93741 4.46339 3.71455 4.68392C3.49168 4.90446 3.31387 5.16733 3.19127 5.45751C3.06866 5.74769 3.00367 6.0595 3 6.37513V20.6249C3.00367 20.9405 3.06866 21.2523 3.19127 21.5425C3.31387 21.8327 3.49168 22.0955 3.71455 22.3161C3.93741 22.5366 4.20096 22.7105 4.49016 22.8278C4.77935 22.9451 5.08852 23.0036 5.4 22.9998H15.6C15.9115 23.0036 16.2207 22.9451 16.5098 22.8278C16.799 22.7105 17.0626 22.5366 17.2855 22.3161C17.5083 22.0955 17.6861 21.8327 17.8087 21.5425C17.9313 21.2523 17.9963 20.9405 18 20.6249V9.70007C17.9994 9.46463 17.9125 9.2378 17.7562 9.06358ZM12.375 5.90014L15.8812 9.70007H13.0687C12.9706 9.69406 12.8746 9.6683 12.7863 9.62429C12.6981 9.58028 12.6194 9.5189 12.5548 9.44373C12.4902 9.36856 12.441 9.28111 12.4102 9.18648C12.3793 9.09185 12.3674 8.99194 12.375 8.89258V5.90014Z'
        fill='currentColor'
      />
      <path
        d='M7.49977 2.33099L16.9953 2.33054C18.6522 2.33046 19.9955 3.67362 19.9955 5.33053L19.9955 19.6449'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_3645_10984'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>,
  'CopyIcon',
)
